class MainCart {
  constructor() {
    this.cartInfo = JSON.parse(document.getElementById('cart-info-json').textContent)

    // カート内商品のJSON
    this.cartItemsJSON = document.getElementById('cart-items-json')
    this.cartItemsData = this.cartItemsJSON ? JSON.parse(this.cartItemsJSON.textContent) : null

    this.baseItemCount = this.cartInfo.baseItems
    this.itemCount = this.cartInfo.itemCount
    this.rapidShipping = this.cartInfo.rapidShipping
    this.rapidShippingId = this.cartInfo.rapidShippingId
    this.freeRapidShippingId = this.cartInfo.freeRapidShippingId
    this.isPickup = this.cartInfo.isPickup
    this.pickupId = this.cartInfo.pickupId
    this.$cartItems = document.querySelectorAll('[data-cart-item]')

    this.$dummyCta = document.querySelector('[data-dummy-cta]')
    this.$surveyInputs = document.querySelectorAll('[data-survey-input]')

    this.$checkoutBtn = document.getElementById('checkout')

    this.$attrResetInputs = document.querySelectorAll('[data-attribute-reset-input]')

    this.recommendSlider = null

    this.$timeStampInput = document.getElementById('display_date_timestamp')
  }

  initialize() {
    // 配送オプションだけの場合はカートをクリアする
    if (this.cartInfo.onlyShippingOptions) {
      MainCart.clearCart()
    }

    // ベース商品がない場合（オプションのみの場合）、もしくは配送関連商品のみの場合に削除する
    if (this.cartItemsData) {
      this.checkEmptyBaseItems()
    }

    // カート内商品の制御
    this.$cartItems.forEach(($cartItem) => {
      this.initCartItem($cartItem)
    })

    // // カート表示タイムスタンプ
    // const currentTimeStamp = new Date()
    // const timeStampFormData = new FormData()
    // timeStampFormData.append(
    //   'attributes[_カート表示時刻]',
    //   `${currentTimeStamp.getFullYear()}/${
    //     currentTimeStamp.getMonth() + 1
    //   }/${currentTimeStamp.getDate()} ${currentTimeStamp.getHours()}:${currentTimeStamp.getMinutes()}:${currentTimeStamp.getSeconds()}`
    // )
    // fetch(window.Shopify.routes.root + 'cart/update.js', {
    //   method: 'POST',
    //   body: timeStampFormData,
    // })

    // // 初回カート表示タイムスタンプ
    // const formattedTimeStamp = `${currentTimeStamp.getFullYear()}/${
    //   currentTimeStamp.getMonth() + 1
    // }/${currentTimeStamp.getDate()} ${currentTimeStamp.getHours()}:${
    //   currentTimeStamp.getMinutes()
    // }:${currentTimeStamp.getSeconds()}`;

    // fetch(window.Shopify.routes.root + 'cart.js')
    //   .then(response => response.json())
    //   .then(cart => {
    //     if (cart.items && cart.items.length > 0) {
    //       if (!cart.attributes || !cart.attributes['_初回カート表示時刻']) {
    //         const formData = new FormData();
    //         formData.append('attributes[_初回カート表示時刻]', formattedTimeStamp);
    //         fetch(window.Shopify.routes.root + 'cart/update.js', {
    //           method: 'POST',
    //           body: formData,
    //         })
    //       }
    //     }
    //   })

    const currentTimeStamp = new Date()
    const formattedTimeStamp = `${currentTimeStamp.getFullYear()}/${
      currentTimeStamp.getMonth() + 1
    }/${currentTimeStamp.getDate()} ${currentTimeStamp.getHours()}:${currentTimeStamp.getMinutes()}:${currentTimeStamp.getSeconds()}`

    // 初回カート表示タイムスタンプを確認・設定
    async function setInitialCartTimestamp(formattedTimeStamp) {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js')
      const cart = await cartResponse.json()

      if (cart.items && cart.items.length > 0) {
        if (!cart.attributes || !cart.attributes['_初回カート表示時刻']) {
          const formData = new FormData()
          formData.append('attributes[_初回カート表示時刻]', formattedTimeStamp)
          await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: formData,
          })
        }
      }
    }

    // カート表示タイムスタンプを更新
    async function updateCartTimestamp(formattedTimeStamp) {
      const timeStampFormData = new FormData()
      timeStampFormData.append('attributes[_カート表示時刻]', formattedTimeStamp)

      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: timeStampFormData,
      })
    }

    async function updateTimestamps() {
      await setInitialCartTimestamp(formattedTimeStamp)
      // await updateCartTimestamp(formattedTimeStamp);
    }

    updateTimestamps()

    // アンケートの制御
    this.handleSurvey()

    // ダミーボタンの制御
    this.$dummyCta.addEventListener('click', () => {
      const validated = this.validateSurvey()
      if (validated) {
        // 不要なattributesをリセットする
        if (this.$attrResetInputs.length) {
          this.resetShippingAttributes()
        }
        this.$checkoutBtn.click()
      }
    })

    // レコメンドスライダー
    if (document.querySelector('[data-cart-recommend-slider]')) {
      this.handleSlider()
      // 画面サイズでスライダー表示切り替え
      window.addEventListener('resize', () => {
        this.handleSlider()
      })
    }

    // セレクトボックスのエラーメッセージカスタマイズ
    // 都道府県
    const provinceSel = document.querySelector('select[name="province_for_delivery_date"]')
    if (provinceSel) {
      provinceSel.addEventListener('invalid', () => {
        if (provinceSel.validity.valueMissing) {
          provinceSel.setCustomValidity('都道府県を選択して下さい')
        }
      })
      provinceSel.addEventListener('change', () => {
        provinceSel.setCustomValidity('')
      })
    }

    // 配送希望日
    const delivDateSel = document.querySelector('select[name="attributes[お届け日指定]"]')
    if (delivDateSel) {
      delivDateSel.addEventListener(
        'invalid',
        () => {
          if (delivDateSel.validity.valueMissing) {
            delivDateSel.setCustomValidity('希望日を選択して下さい')
          }
        },
        false
      )
      delivDateSel.addEventListener('change', () => {
        delivDateSel.setCustomValidity('')
      })
    }
    // 配送希望時間
    const delivTimeSel = document.querySelector('select[name="attributes[お届け時間指定]"]')
    if (delivTimeSel) {
      delivTimeSel.addEventListener(
        'invalid',
        () => {
          if (delivTimeSel.validity.valueMissing) {
            delivTimeSel.setCustomValidity('希望時間を選択して下さい')
          }
        },
        false
      )
      delivTimeSel.addEventListener('change', () => {
        delivTimeSel.setCustomValidity('')
      })
    }

    // 受け取り希望日
    const pickDateSel = document.querySelector('select[name="attributes[店頭受取希望日]"]')
    if (pickDateSel) {
      pickDateSel.addEventListener(
        'invalid',
        () => {
          if (pickDateSel.validity.valueMissing) {
            pickDateSel.setCustomValidity('希望日を選択して下さい')
          }
        },
        false
      )
      pickDateSel.addEventListener('change', () => {
        pickDateSel.setCustomValidity('')
      })
    }
    // 受け取り希望日
    const pickTimeSel = document.querySelector('select[name="attributes[時間指定]"]')
    if (pickTimeSel) {
      pickTimeSel.addEventListener(
        'invalid',
        () => {
          if (pickTimeSel.validity.valueMissing) {
            pickTimeSel.setCustomValidity('希望時間を選択して下さい')
          }
        },
        false
      )
      pickTimeSel.addEventListener('change', () => {
        pickTimeSel.setCustomValidity('')
      })
    }
  }

  checkEmptyBaseItems() {
    const baseItemIds = []
    // ベース商品の「ベース商品ID」を格納
    this.cartItemsData.forEach((data) => {
      if (data.product_type !== 'カスタマイズ' && data.properties['_商品タイプ'] === 'ベース') {
        baseItemIds.push(data.properties['ベース商品ID'])
      }
    })

    const emptyBaseOptionKeys = []
    // 「ベース商品ID」が合致するベース商品が存在しないオプションのIDをまとめる
    this.cartItemsData.forEach((data) => {
      if (data.properties['_商品タイプ'] === 'カスタマイズ' && !baseItemIds.includes(data.properties['ベース商品ID'])) {
        emptyBaseOptionKeys.push(data.key)
      }
    })

    if (emptyBaseOptionKeys.length > 0) {
      const updates = {}
      emptyBaseOptionKeys.forEach((key) => {
        updates[key] = 0
      })

      // ローディング表示
      document.querySelector('.c-cart-loader').classList.add('is-visible')
      MainCart.updateCart(updates)
    }
  }

  initCartItem($cartItem) {
    const variantId = $cartItem.dataset.cartItem
    const quantity = Number($cartItem.dataset.cartItemQty)
    const optionIds = $cartItem.dataset.appliedOptionIds !== '' ? $cartItem.dataset.appliedOptionIds.split(',') : []
    const isBaseItem = $cartItem.dataset.isBaseItem === 'true'
    const isFreeRapid = $cartItem.dataset.isFreeRapid === 'true'

    // アイテム削除
    $cartItem.querySelectorAll('[data-cart-item-delete]').forEach((deleteBtn) => {
      deleteBtn.addEventListener('click', () => {
        // ローディング表示
        document.querySelector('.c-cart-loader').classList.add('is-visible')

        const updates = {}
        updates[variantId] = 0

        // 紐づくオプション商品があれば同時に削除
        if (optionIds.length > 0) {
          optionIds.forEach((id) => {
            updates[id] = 0
          })
        }

        // ベース商品かつ超速商品があれば同時に削除
        if (this.rapidShipping && isBaseItem) {
          if (isFreeRapid) {
            updates[this.freeRapidShippingId] = this.cartInfo.freeRapidShippingCount - quantity
          } else {
            updates[this.rapidShippingId] = this.cartInfo.rapidShippingCount - quantity
          }
        }

        MainCart.updateCart(updates)
      })
    })

    // アイテム追加
    $cartItem.querySelectorAll('[data-cart-item-add]').forEach((addBtn) => {
      addBtn.addEventListener('click', () => {
        const updatedQty = quantity + 1
        const updates = {}
        updates[variantId] = updatedQty

        // 紐づくオプション商品があれば同時に追加
        if (optionIds.length > 0) {
          optionIds.forEach((id) => {
            updates[id] = updatedQty
          })
        }

        // ベース商品かつ超速商品があれば同時に追加
        if (this.rapidShipping) {
          // 超速が無料かどうか
          if (addBtn.dataset.cartItemAdd === 'freeRapid') {
            updates[this.freeRapidShippingId] = this.cartInfo.freeRapidShippingCount + 1
          } else {
            updates[this.rapidShippingId] = this.cartInfo.rapidShippingCount + 1
          }
        }

        MainCart.updateCart(updates)
      })
    })
    // アイテム減らす
    $cartItem.querySelectorAll('[data-cart-item-reduce]').forEach((reduceBtn) => {
      reduceBtn.addEventListener('click', () => {
        const updatedQty = quantity - 1
        const updates = {}
        updates[variantId] = updatedQty

        // 紐づくオプション商品があれば同時に減らす
        if (optionIds.length > 0) {
          optionIds.forEach((id) => {
            updates[id] = updatedQty
          })
        }

        // ベース商品かつ超速商品があれば同時に減らす
        if (this.rapidShipping) {
          // 超速が無料かどうか
          if (reduceBtn.dataset.cartItemReduce === 'freeRapid') {
            updates[this.freeRapidShippingId] = this.cartInfo.freeRapidShippingCount - 1
          } else {
            updates[this.rapidShippingId] = this.cartInfo.rapidShippingCount - 1
          }
        }

        MainCart.updateCart(updates)
      })
    })
  }

  // 不要な配送関連attributesをリセット
  resetShippingAttributes() {
    this.$attrResetInputs.forEach((el) => {
      el.value = ''
    })
  }

  // アンケートの挙動
  handleSurvey() {
    // 日付入力の制御（hiddenのinputに値を入れる）
    const dateRadios = document.querySelectorAll('input[name="survey_date"]')
    const dateTextInput = document.querySelector('input[name="survey_date_value"]')
    const dateHiddenInput = document.querySelector('[data-survey-hidden-input]')

    const setHiddenValue = (value) => {
      dateHiddenInput.value = value
      dateHiddenInput.dispatchEvent(new Event('change'))
    }
    dateTextInput.addEventListener('input', () => {
      setHiddenValue(dateTextInput.value)
    })
    if (dateRadios && dateRadios.length > 0) {
      dateRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (radio.value === '未定') {
            setHiddenValue(radio.value)
            // dateTextInput.removeEventListener('input', () => {
            //   setHiddenValue(dateTextInput.value)
            // })
          } else {
            setHiddenValue(dateTextInput.value)
            // dateTextInput.addEventListener('input', () => {
            //   setHiddenValue(dateTextInput.value)
            // })
          }
        })
      })
    }

    // アンケートの入力項目を監視してattributeをアップデート
    this.$surveyInputs.forEach((el) => {
      el.addEventListener('change', (e) => {
        const name = e.target.getAttribute('name')
        const formData = new FormData()
        formData.append(name, e.target.value)
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData,
        })
      })
    })
  }

  // アンケートのバリデーション
  validateSurvey() {
    let validated = true

    this.$surveyInputs.forEach(($input) => {
      const isRequired = $input.dataset.validate === 'required'
      const isDateInput = $input.getAttribute('type') === 'hidden'
      if ((isRequired && $input.value === '') || $input.value.length > 200) {
        validated = false
        if (isDateInput && document.querySelector('[data-survey-date-needs-text]').checked) {
          // 日付入力のみ未入力の場合
          $input.closest('.input-wrap').classList.remove('is-error')
          $input.closest('.input-wrap').classList.add('is-error-only-text')
        } else {
          $input.closest('.input-wrap').classList.remove('is-error-only-text')
          $input.closest('.input-wrap').classList.add('is-error')
          $input.classList.add('is-error')
        }
      } else {
        $input.classList.remove('is-error')
        $input.closest('.input-wrap').classList.remove('is-error')
        $input.closest('.input-wrap').classList.remove('is-error-only-text')
      }
    })

    if (!validated) {
      const surveyArea = window.scrollY + document.getElementById('survey').getBoundingClientRect().top - 100
      window.scrollTo({
        top: surveyArea,
        left: 0,
        behavior: 'smooth',
      })
    }

    return validated
  }

  // こちらも一緒にいかがですかスライダー
  handleSlider() {
    if (MainCart.checkMobile() && !this.recommendSlider) {
      this.createSwiper()
    } else if (!MainCart.checkMobile() && this.recommendSlider) {
      this.destroySwiper()
    }
  }
  createSwiper() {
    this.recommendSlider = new Swiper('[data-cart-recommend-slider]', {
      slidesPerView: 2.4,
      spaceBetween: 8,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false,
      },
      scrollbar: {
        el: '[data-cart-recommend-scroller]',
        draggable: true,
      },
      mousewheel: {
        enabled: true,
        sensitivity: 1,
        forceToAxis: true,
      },
    })
  }
  destroySwiper() {
    this.recommendSlider.destroy()
    this.recommendSlider = null
  }

  static clearCart = async () => {
    try {
      await fetch('/cart/clear.js', {
        method: 'GET',
      })

      location.reload()
    } catch (e) {
      console.error('Error:', e)
    }
  }

  static updateCart = async (updates) => {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      })

      const result = await res.json()

      if (result) {
        location.reload()
      }
    } catch (e) {
      console.error('Error:', e)
    }
  }

  static addCart = async (items) => {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(items),
      })

      const result = await res.json()

      if (result) {
        location.reload()
      }
    } catch (e) {
      console.error('Error:', e)
    }
  }

  // 超速配送商品を追加
  static addRapidShipping(id, baseItemCount, freeId, freeBaseItemCount) {
    const reqBody = {
      items: [],
    }

    // 有料超速
    if (baseItemCount > 0) {
      reqBody.items.push({
        id: id,
        quantity: baseItemCount,
      })
    }

    // 無料超速
    if (freeBaseItemCount > 0) {
      reqBody.items.push({
        id: freeId,
        quantity: freeBaseItemCount,
      })
    }

    MainCart.addCart(reqBody)
  }

  // 超速配送商品を削除
  static removeRapidShipping(id, freeId) {
    const reqBody = {}
    reqBody[id] = 0
    reqBody[freeId] = 0

    MainCart.updateCart(reqBody)
  }

  // 店頭受け取り商品を追加
  static addPickupItem(id) {
    const reqBody = {
      items: [
        {
          id: id,
          quantity: 1,
        },
      ],
    }

    MainCart.addCart(reqBody)
  }

  // 店頭受け取り商品を削除
  static removePickupItem(id) {
    const reqBody = {}
    reqBody[id] = 0

    MainCart.updateCart(reqBody)
  }

  // モバイル判定
  static checkMobile() {
    return window.matchMedia('screen and (max-width: 760px)').matches
  }
}

;(function () {
  // back forward cache対策
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      window.location.reload()
    }
  })
  const handler = new MainCart()
  handler.initialize()
})()
